import getShortenEventsDurationBy from './getShortenEventsDurationBy';
import getDefaultEventDuration from 'owa-session-store/lib/selectors/getDefaultEventDuration';

/**
 * Update the event duration when the 'End events early'/'Shorten events duration' setting is on
 */
export default function getConfiguredDefaultEventDuration(): number {
    const defaultDuration: number = getDefaultEventDuration();
    const reduceEventBy = getShortenEventsDurationBy(defaultDuration);

    return Math.max(defaultDuration - reduceEventBy, 0);
}
